<template>
	<div class="mportsFormHeader puiformheader">
	</div>
</template>

<script>
import PuiFormHeaderMixin from '@Pui9Mixins/PuiFormHeaderMixin';

export default {
	name: 'mports-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'mports'
		};
	},
	computed: {
	}
}
</script>
